require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-veldstation-saeftinghe.json") })
        }
      }, "path---projecten-veldstation-saeftinghe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-veldstation-saeftinghe!./.cache/json/projecten-veldstation-saeftinghe.json
// module id = 452
// module chunks = 231608221292675